import { urls } from "../Utils/Urls";
import { Request } from "./Request";

const TENANT_ID = "br";

// Minimal RequestInfo envelope. The shared Request helper injects `authToken`
// when a session token exists, but the visit endpoints are public, so an
// auth-less envelope is accepted for unauthenticated landing-page visitors.
const buildRequestInfo = (msgId) => ({
  apiId: "dfs",
  ver: "1.0",
  ts: Date.now(),
  msgId,
});

// The Request helper never throws — it returns the axios response (or a
// synthetic 500), so read the total defensively and return null when it is
// unavailable, letting the caller fall back to its cached/placeholder value.
const readTotal = (response) => {
  const total = response?.data?.totalVisits;
  return typeof total === "number" ? total : null;
};

export const VisitCounterService = {
  // POST _count — records one visit and returns the updated grand total.
  // Call once per browser session (the caller guards this).
  recordVisit: async ({ tenantId = TENANT_ID } = {}) => {
    const response = await Request({
      url: urls.visit_count,
      data: { RequestInfo: buildRequestInfo("visit|en_IN"), visit: { tenantId } },
    });
    return readTotal(response);
  },

  // POST _total — read-only; returns the grand total without incrementing.
  getTotalVisits: async ({ tenantId = TENANT_ID } = {}) => {
    const response = await Request({
      url: urls.visit_total,
      data: { RequestInfo: buildRequestInfo("visit-total|en_IN"), visit: { tenantId } },
    });
    return readTotal(response);
  },
};
